import { render, staticRenderFns } from "./FieldDescriptionsModal.vue?vue&type=template&id=6e022115&scoped=true&"
import script from "./FieldDescriptionsModal.vue?vue&type=script&lang=js&"
export * from "./FieldDescriptionsModal.vue?vue&type=script&lang=js&"
import style0 from "./FieldDescriptionsModal.vue?vue&type=style&index=0&id=6e022115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e022115",
  null
  
)

export default component.exports